const Ok = (data)=>({
        val: data,
        err: false,
        ok: true
    });
const Err = (error)=>({
        val: error,
        err: true,
        ok: false
    });
const Result = {
    fromAsync: async (promise)=>{
        try {
            const data = await promise;
            return Ok(data);
        } catch (error) {
            return Err(error);
        }
    },
    from: (fnOrValue)=>{
        try {
            if (typeof fnOrValue === "function") {
                const callee = fnOrValue;
                return Ok(callee());
            }
            return Ok(fnOrValue);
        } catch (error) {
            return Err(error);
        }
    },
    unwrap: (result)=>{
        if (result.err) {
            throw result.val;
        }
        return result.val;
    },
    unwrapOr: (result, fallback)=>{
        if (result.err) {
            return fallback;
        }
        return result.val;
    },
    isResult: (result)=>{
        return "ok" in result && "err" in result && "val" in result;
    }
};

export { Err, Ok, Result };
